import type { PendingEnrolment } from './actions'
import type { SubmitError } from './confirmation'
import { initialState as enrolmentDraftInitialState } from './reducer'

type RootState = {
  enrolmentDraft: typeof enrolmentDraftInitialState
}

const selectEnrolmentDraftState = (state: RootState) =>
  state.enrolmentDraft || enrolmentDraftInitialState

export const selectUnenrolments = (
  state: RootState,
): Record<string, true> =>
  selectEnrolmentDraftState(state).unenrolments

export const selectPendingEnrolments = (
  state: RootState,
): Record<string, PendingEnrolment> =>
  selectEnrolmentDraftState(state).enrolments

export const selectIsMarkedForUnenrolment = (
  state: RootState,
  enrolmentId: string,
): boolean =>
  Boolean(selectEnrolmentDraftState(state).unenrolments[enrolmentId])

export const selectDraftChangeCount = (state: RootState): number => {
  const { unenrolments, enrolments } = selectEnrolmentDraftState(state)
  return Object.keys(unenrolments).length + Object.keys(enrolments).length
}

export const selectDraftScope = (state: RootState): string | null =>
  selectEnrolmentDraftState(state).scope

export const selectIsSubmitting = (state: RootState): boolean =>
  selectEnrolmentDraftState(state).submitting

export const selectSubmitFailed = (state: RootState): boolean =>
  selectEnrolmentDraftState(state).submitFailed

export const selectSubmitStatus = (state: RootState): number | null =>
  selectEnrolmentDraftState(state).submitStatus

export const selectSubmitErrors = (state: RootState): SubmitError[] =>
  selectEnrolmentDraftState(state).submitErrors

export const selectConfirmed = (state: RootState): boolean =>
  selectEnrolmentDraftState(state).confirmed
